'use client';
import InputGroup from "./InputGroup.js";
export default InputGroup;